<template>
    <div>
        <NavBarLight></NavBarLight><br><br>
        <div class="dashboard-content">
            <div class="row">
                <div id="header-image">
                    <h1 class="header-text">Find your dream job</h1>
                </div>
                <div class="container" id="job-cards">
                    <div class="row">
                        <pulse-loader class="loader"
                            :loading="loading"
                            :color="color"
                            :size="size">
                        </pulse-loader>
                        <JobCard v-for="(job, index) in jobs" :key="index" class="job-card"
                            v-bind:slug="job.slug"
                            v-bind:jobObj = "job"
                            v-bind:iconUrl="job.icon"
                            v-bind:status="job.status"
                            v-bind:position="job.position"
                            v-bind:location="job.location"
                            v-bind:experience="job.experience"
                            v-bind:clickFunction="clickFunc">
                        </JobCard>
                        
                    </div>
                </div>
				
			</div>
            
        </div>
       
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import NotifyCard from '@/components/NotifyCard.vue'
import JobCard from '@/components/JobCard.vue'
import firebase from '../services/firebase'
import _ from 'lodash'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


export default {
    name: 'Jobs',
    components: {
        NavBarLight,
        NotifyCard,
        JobCard,
        PulseLoader
    },
    data: function() {
        return {
            loading: true,
            color: '#524aed',
            size: '8px'
        }
    },
    /*
    firebase: {
        jobs: firebase.database().ref('jobs').orderByChild('timestamp')
    },*/
    firebase() {
        return {
            jobs: {
                source: firebase.database().ref('jobs').orderByChild('timestamp'),
                readyCallback: () => this.loading = false
            }
        }
    },
    methods: {
        clickFunc: function(slug, apply, status) {
            mixpanel.track("clicked on job", 
            {
                "company_name": slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.$router.push('/dashboard/apply/' + slug);
            
        }
    }
}

</script>


<style>

    .dashboard-content {
        padding-top:30px;
        background-color: #f8faff;
    }

    .header-text {
        margin-top:20px;
        font-size: 1.5em;
    }

    @media (min-width: 430px) {
        #header-image {
            margin-top:20px; 
            color:#555;
            margin-left:14.7%;
            margin-right:14.7%;
            margin-bottom:20px;
        }
    }
    
    .container {
        margin-bottom:100px;
    }

    .job-card{
        width:28.7%;
    }

    @media (min-width: 768px) and (max-width: 992px) {
        .job-card {
            width: 45%;
        }

        #header-image {
            margin-top:3%; 
            color:#555;
            margin-left:16%;
            margin-right:13%;
            margin-bottom:20px;
        }
    }

    @media (min-width: 600px) and (max-width: 768px) {
        .job-card {
            width: 70%;
            margin: auto;
        }

        #header-image {
            margin-top:2%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }

    }

    @media (min-width: 430px) and (max-width:600px) {
        .job-card {
            width: 80%;
            margin: auto;
        }

        #header-image {
            margin-top:7%; 
            color:#555;
            margin-left:10%;
            margin-right:10%;
            margin-bottom:20px;
        }

    }

    @media (max-width:430px) {
        .job-card {
            width: 90%;
            margin:auto;
        }

        #header-image {
            margin-top:11%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }
    }

    @media (min-width: 768px) {
        #job-cards {
            margin-left:11.9%;
        }
    }


</style>